import React, { Component } from 'react';
import { Container, Row, UncontrolledAccordion, AccordionItem, AccordionHeader, UncontrolledTooltip } from 'reactstrap';
import { Puntaje } from './Puntaje';
function redondearHaciaArriba(valor: number): number {
    const decimal = valor % 1;
    return decimal >= 0.5 ? Math.ceil(valor) : Math.floor(valor);
}

export class DetalleScore extends Component {

    constructor(props) {
        super(props);
        this.state = { proveedor: props.proveedor };
    }

    render() {

        return (
            <Container>
                <Row>

                    {/* ================= COLUMNA IZQUIERDA ================= */}
                    <div className="col-4">

                        <UncontrolledAccordion>

                            <AccordionItem
                                className={"factor c" + this.state.proveedor.FactoresQueSuman[5].color}
                                style={{ marginLeft: "18%", marginRight: "-18%" }}
                                id="factor5"
                            >
                                <AccordionHeader targetId="collapseS5">
                                    {this.state.proveedor.FactoresQueSuman[5].nombre}
                                    <span>
                                        {this.state.proveedor.FactoresQueSuman[5].color === 3
                                            ? <> - </>
                                            : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[5].valor)}
                                    </span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor5" >
                                {this.state.proveedor.FactoresQueSuman[5].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[5].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>

                            <AccordionItem
                                className={"factor c" + this.state.proveedor.FactoresQueSuman[4].color}
                                id="factor4"
                            >
                                <AccordionHeader targetId="collapseS4">
                                    {this.state.proveedor.FactoresQueSuman[4].nombre}
                                    <span>
                                        {this.state.proveedor.FactoresQueSuman[4].color === 3
                                            ? <> - </>
                                            : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[4].valor)}
                                    </span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor4" >
                                {this.state.proveedor.FactoresQueSuman[4].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[4].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>

                            <AccordionItem
                                className={"factor c" + this.state.proveedor.FactoresQueSuman[3].color}
                                style={{ marginLeft: "-18%", marginRight: "18%" }}
                                id="factor3"
                            >
                                <AccordionHeader targetId="collapseS3">
                                    {this.state.proveedor.FactoresQueSuman[3].nombre}
                                    <span>
                                        {this.state.proveedor.FactoresQueSuman[3].color === 3
                                            ? <> - </>
                                            : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[3].valor)}
                                    </span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor3" >
                                {this.state.proveedor.FactoresQueSuman[3].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[3].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>

                            <AccordionItem
                                className={"factor c" + this.state.proveedor.FactoresQueSuman[0].color}
                                id="factor0"
                            >
                                <AccordionHeader targetId="collapseS0">
                                    {this.state.proveedor.FactoresQueSuman[0].nombre}
                                    <span>
                                        {this.state.proveedor.FactoresQueSuman[0].color === 3
                                            ? <> - </>
                                            : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[0].valor)}
                                    </span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor0" >
                                {this.state.proveedor.FactoresQueSuman[0].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[0].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>

                            <AccordionItem
                                className={"factor c" + this.state.proveedor.FactoresQueSuman[6].color}
                                style={{ marginLeft: "18%", marginRight: "-18%" }}
                                id="factor6"
                            >
                                <AccordionHeader targetId="collapseS6">
                                    {this.state.proveedor.FactoresQueSuman[6].nombre}
                                    <span>
                                        {this.state.proveedor.FactoresQueSuman[6].color === 3
                                            ? <> - </>
                                            : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[6].valor)}
                                    </span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor6" >
                                {this.state.proveedor.FactoresQueSuman[6].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[6].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>

                        </UncontrolledAccordion>

                        <div className="extra">
                            Por consultas comun�cate con el Centro de Atenci�n a Proveedores<br />
                            <a href="mailto:score@proveedoresypf.com">score@proveedoresypf.com</a>
                        </div>
                    </div>

                    {/* ================= COLUMNA CENTRAL ================= */}
                    <div className="col-4">
                        <Puntaje proveedor={this.state.proveedor} />
                    </div>

                    {/* ================= COLUMNA DERECHA ================= */}
                    <div className="col-4">

                        {/* WRAPPER QUE EVITA SOLAPAMIENTO CON FOOTER */}
                        <div className="factores-restan-wrapper">
                            <UncontrolledAccordion style={{ textAlign: "center", marginTop: "30px" }}>
                                <AccordionItem className="factorr">
                                    <div>
                                        {this.state.proveedor.factoresQueRestan[1].nombre}<br />
                                        <img
                                            src={this.state.proveedor.factoresQueRestan[1].ok ? "/check-ok.svg" : "/check-x.svg"}
                                            alt="estado"
                                            width="28px"
                                        />
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="factorr">
                                    <div>
                                        {this.state.proveedor.factoresQueRestan[2].nombre}<br />
                                        <img
                                            src={this.state.proveedor.factoresQueRestan[2].ok ? "/check-ok.svg" : "/check-x.svg"}
                                            alt="estado"
                                            width="28px"
                                        />
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="factorr">
                                    <div>
                                        {this.state.proveedor.factoresQueRestan[0].nombre} (**)<br />
                                        <img
                                            src={this.state.proveedor.factoresQueRestan[0].ok ? "/check-ok.svg" : "/check-x.svg"}
                                            alt="estado"
                                            width="28px"
                                        />
                                    </div>
                                </AccordionItem>
                            </UncontrolledAccordion>
                        </div>

                        <UncontrolledAccordion>
                            <AccordionItem className="factor neutro" id="factor1">
                                <AccordionHeader targetId="collapseS1">
                                    <span style={{ float: "left", backgroundColor: "gray" }}>
                                        {this.state.proveedor.FactoresQueSuman[1].color === 3
                                            ? <> - </>
                                            : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[1].valor)}
                                    </span>
                                    {this.state.proveedor.FactoresQueSuman[1].nombre} (*)
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="left" target="factor1" >
                                {this.state.proveedor.FactoresQueSuman[1].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[1].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>

                            <AccordionItem className="factor neutro" id="factor2">
                                <AccordionHeader targetId="collapseS2">
                                    <span style={{ float: "left", backgroundColor: "gray" }}>
                                        {this.state.proveedor.FactoresQueSuman[2].color === 3
                                            ? <> - </>
                                            : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[2].valor)}
                                    </span>
                                    {this.state.proveedor.FactoresQueSuman[2].nombre} (*)
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="left" target="factor2" >
                                {this.state.proveedor.FactoresQueSuman[2].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[2].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>
                        </UncontrolledAccordion>

                        <h6>* Estos factores no impactan en el puntaje final.</h6>
                        <h6>** Cuestionario de Debida Diligencia</h6>

                        <div className="extra">
                            <a href="https://walink.co/013024" target="_blank" rel="noreferrer">
                                <img src="/chatbot.png" alt="Chatbot" />
                            </a>
                        </div>

                    </div>
                </Row>
            </Container>
        );
    }
}